import React, { ReactNode, useState } from 'react';

type Props = {
  children: ReactNode;
  text: string;
  delay: number;
};

export default function Tooltip({ children, text, delay }: Props) {
  const [showTooltip, setShowTooltip] = useState<boolean>(false);
  let mouseLeft = false;

  const onMouseEnter = (): void => {
    mouseLeft = false;
    setTimeout(() => {
      if (!mouseLeft) {
        setShowTooltip(true);
      }
    }, delay);
  };

  const onMouseLeave = (): void => {
    mouseLeft = true;
    setShowTooltip(false);
  };

  const toggleTooltip = (): void => {
    setShowTooltip(!showTooltip);
  };

  const hideTooltip = (): void => {
    setShowTooltip(false);
  };

  return (
    <div className="relative">
      <span
        className={`text-base absolute min-w-max z-50 py-2 px-4 rounded-md bg-white border border-solid
            bottom-full mb-3 shadow-search transform -translate-x-1/2 left-1/2  ${
              showTooltip ? 'inline-block' : 'hidden'
            }`}
      >
        {text}
        <div className="absolute w-3 top-full overflow-hidden inline-block transform -translate-x-1/2 left-1/2">
          <div className="h-2 w-2 bg-white -rotate-45 transform origin-top-left" />
        </div>
      </span>
      <span className="hidden d:block" onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
        {children}
      </span>
      <span
        className="block d:hidden"
        onClick={toggleTooltip}
        onKeyDown={toggleTooltip}
        onBlur={hideTooltip}
        role="button"
        tabIndex={0}
      >
        {children}
      </span>
    </div>
  );
}
